import React from 'react';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { useQueryClient } from '@tanstack/react-query';
import { Grid } from 'antd';
import { MenuDropdown } from 'app/atoms';
import { UserResponse } from 'app/modules/Auth/types';
import { UserRoleLabelMap } from 'enums/user';
import NavBreadcrumb from '../NavBreadcrumb/NavBreadcrumb';

const { useBreakpoint } = Grid;

interface HeaderProps {
  collapsed: boolean;
  setCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
}

const Header: React.FC<HeaderProps> = ({ collapsed, setCollapsed }) => {
  const queryClient = useQueryClient();
  const userInfo = queryClient.getQueryData<UserResponse>(['auth', 'user-info']);
  const { lg: isDesktop } = useBreakpoint();

  return (
    <header className="bg-white w-full">
      <div className="flex leading-6 px-4 py-4 items-center bg-white shadow-sm w-full">
        {!isDesktop &&
          React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
            className: 'text-lg mr-4 cursor-pointer',
            onClick: () => setCollapsed(!collapsed),
          })}

        <NavBreadcrumb />

        <div className="ml-auto flex items-center gap-4">
          <MenuDropdown>
            <div className="flex items-center gap-2 cursor-pointer" data-testid="profile-dropdown-button">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-orange-100 text-orange-700 font-semibold">
                {userInfo?.displayName?.charAt(0).toUpperCase() ?? userInfo?.email?.charAt(0).toUpperCase() ?? 'U'}
              </div>
              <div className="hidden sm:flex flex-col leading-tight">
                <p className="text-black text-sm font-medium">{userInfo?.displayName || userInfo?.email}</p>
                {userInfo?.role && <p className="text-xs text-gray-400">{UserRoleLabelMap[userInfo.role]}</p>}
              </div>
            </div>
          </MenuDropdown>
        </div>
      </div>
    </header>
  );
};

export default Header;
